<template>
  <div>微信页面</div>
  <div>{{ state.code }}</div>
  <div>{{ state.openid }}</div>
</template>
<script setup>
  import { reactive, onMounted } from 'vue'
  import { queryOpenId, queryPayInfo } from '@/api/wechat/wechatAuto'
  import { useRoute } from 'vue-router'
  const route = useRoute()
  const queryInfo = () => {
    let pageUrl = `https://wx.sxmfyy.com/auth/baizhe.wechat-auth.top/wechatPay`
    // let pageUrl = location.href.split('#')[0]
    window.location.href =
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfc937b083526e89e&redirect_uri=' +
      encodeURIComponent(pageUrl) +
      '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
    return
  }
  const state = reactive({})
  onMounted(() => {
    if (route.query.code) {
      console.log(route.query)
      const code = route.query.code
      const adviceCode = route.query.adviceCode
      const subjectCode = route.query.subjectCode
      queryOpenId({ code }).then(v => {
        const { data } = v
        // const openId = data.openid
        state.openid = data.openid
        // queryPayInfo({ adviceCode, openId, subjectCode }).then(v => {
        //   const { data } = v
        //   console.log(data)
        // })
      })
      state.code = code
    } else {
      queryInfo()
    }
  })
</script>
